import { createStructuredSelector } from "reselect";
import {
    SPE_PURCHASE_ORDER,
    SPE_PURCHASE_ORDER_SUCCESS,
    SPE_PURCHASE_ORDER_ERROR,
    SPE_SUPPLIER,
    SPE_SUPPLIER_SUCCESS,
    SPE_SUPPLIER_ERROR,
    SPE_CATEGORY,
    SPE_CATEGORY_SUCCESS,
    SPE_CATEGORY_ERROR,
    SPE_PURCHASE_ORDER_STATUS,
    SPE_PURCHASE_ORDER_STATUS_SUCCESS,
    SPE_PURCHASE_ORDER_STATUS_ERROR,
    SPE_USER_ROLE,
    SPE_USER_ROLE_SUCCESS,
    SPE_USER_ROLE_ERROR,
    PO_SPE_LIST,
    PO_SPE_LIST_SUCCESS,
    PO_SPE_LIST_ERROR,
    PO_SPE_LIST_SEARCH_CHANGE,
    PO_SPE_LIST_PAGE_SET,
    SPE_ADD_COMITE_MODAL_SET,
    SPE_ADD_COMITE_CHANGE_SET,
    SPE_ADD_COMITE,
    SPE_ADD_COMITE_SUCCESS,
    SPE_ADD_COMITE_ERROR,
    SPE_ADD_EVALUATION_MODAL_SET,
    SPE_CHECKLIST,
    SPE_CHECKLIST_SUCCESS,
    SPE_CHECKLIST_ERROR,
    SPE_EVALUATION_OPTION,
    SPE_EVALUATION_OPTION_SUCCESS,
    SPE_EVALUATION_OPTION_ERROR,
    SPE_ADD_EVALUATION_CHANGE_SET,
    SPE_ADD_EVALUATION,
    SPE_ADD_EVALUATION_SUCCESS,
    SPE_ADD_EVALUATION_ERROR,
    SPE_CLOSED_EVALUATION_MODAL_SET,
    SPE_CLOSED_EVALUATION_CHANGE_SET,
    SPE_CLOSED_EVALUATION,
    SPE_CLOSED_EVALUATION_SUCCESS,
    SPE_CLOSED_EVALUATION_ERROR,
    SPE_DOWNLOAD_EVALUATION_MODAL_SET,
    SPE_DOWNLOAD_EVALUATION_CHANGE_SET,
    SPE_CHECKLIST_SCORE,
    SPE_CHECKLIST_SCORE_SUCCESS,
    SPE_CHECKLIST_SCORE_ERROR,
    SPE_EDIT_COMITE_MODAL_SET,
    SPE_EDIT_COMITE_CHANGE_SET,
    SPE_EDIT_COMITE,
    SPE_EDIT_COMITE_SUCCESS,
    SPE_EDIT_COMITE_ERROR,
} from "../actions";

export const NAME = 'speTool';

export const SPEPurchaseOrder = (data) => ({
    type: SPE_PURCHASE_ORDER,
    payload: data
});

export const SPEPurchaseOrderSuccess = (data) => ({
    type: SPE_PURCHASE_ORDER_SUCCESS,
    payload: data
});

export const SPEPurchaseOrderError = (error) => ({
    type: SPE_PURCHASE_ORDER_ERROR,
    payload: error
});

export const SPESupplier = (data) => ({
    type: SPE_SUPPLIER,
    payload: data
});

export const SPESupplierSuccess = (data) => ({
    type: SPE_SUPPLIER_SUCCESS,
    payload: data
});

export const SPESupplierError = (error) => ({
    type: SPE_SUPPLIER_ERROR,
    payload: error
});

export const SPECategory = (data) => ({
    type: SPE_CATEGORY,
    payload: data
});

export const SPECategorySuccess = (data) => ({
    type: SPE_CATEGORY_SUCCESS,
    payload: data
});

export const SPECategoryError = (error) => ({
    type: SPE_CATEGORY_ERROR,
    payload: error
});

export const SPEPurchaseOrderStatus = (data) => ({
    type: SPE_PURCHASE_ORDER_STATUS,
    payload: data
});

export const SPEPurchaseOrderStatusSuccess = (data) => ({
    type: SPE_PURCHASE_ORDER_STATUS_SUCCESS,
    payload: data
});

export const SPEPurchaseOrderStatusError = (error) => ({
    type: SPE_PURCHASE_ORDER_STATUS_ERROR,
    payload: error
});

export const SPEUserRole = (data) => ({
    type: SPE_USER_ROLE,
    payload: data
});

export const SPEUserRoleSuccess = (data) => ({
    type: SPE_USER_ROLE_SUCCESS,
    payload: data
});

export const SPEUserRoleError = (error) => ({
    type: SPE_USER_ROLE_ERROR,
    payload: error
});

export const SPEEvaluationOption = (data) => ({
    type: SPE_EVALUATION_OPTION,
    payload: data
});

export const SPEEvaluationOptionSuccess = (data) => ({
    type: SPE_EVALUATION_OPTION_SUCCESS,
    payload: data
});

export const SPEEvaluationOptionError = (error) => ({
    type: SPE_EVALUATION_OPTION_ERROR,
    payload: error
});

export const POSPEList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: PO_SPE_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const POSPEListSuccess = (data) => ({
    type: PO_SPE_LIST_SUCCESS,
    payload: data
});

export const POSPEListError = (error) => ({
    type: PO_SPE_LIST_ERROR,
    payload: error
});

export const POSPEPageSet = (data) => ({
    type: PO_SPE_LIST_PAGE_SET,
    payload: data
});

export const POSPESearchChange = (data) => ({
    type: PO_SPE_LIST_SEARCH_CHANGE,
    payload: data
});

export const SPEAddComiteModalSet = (data) => ({
    type: SPE_ADD_COMITE_MODAL_SET,
    payload: data
});

export const SPEAddComiteChangeSet = (data) => ({
    type: SPE_ADD_COMITE_CHANGE_SET,
    payload: data
});

export const SPEAddComite = (page, num_page, orderBy, filters, data) => ({
    type: SPE_ADD_COMITE,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const SPEAddComiteSuccess = (message) => ({
    type: SPE_ADD_COMITE_SUCCESS,
    payload: message
});

export const SPEAddComiteError = (error) => ({
    type: SPE_ADD_COMITE_ERROR,
    payload: error
});

export const SPEAddEvaluationModalSet = (data) => ({
    type: SPE_ADD_EVALUATION_MODAL_SET,
    payload: data
});

export const SPEChecklist = (data) => ({
    type: SPE_CHECKLIST,
    payload: data
});

export const SPEChecklistSuccess = (data) => ({
    type: SPE_CHECKLIST_SUCCESS,
    payload: data
});

export const SPEChecklistError = (error) => ({
    type: SPE_CHECKLIST_ERROR,
    payload: error
});

export const SPEAddEvaluationChangeSet = (data) => ({
    type: SPE_ADD_EVALUATION_CHANGE_SET,
    payload: data
});


export const SPEAddEvaluation = (page, num_page, orderBy, filters, data) => ({
    type: SPE_ADD_EVALUATION,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});


export const SPEAddEvaluationSuccess = (message) => ({
    type: SPE_ADD_EVALUATION_SUCCESS,
    payload: message
});

export const SPEAddEvaluationError = (error) => ({
    type: SPE_ADD_EVALUATION_ERROR,
    payload: error
});

export const SPEClosedEvaluationModalSet = (data) => ({
    type: SPE_CLOSED_EVALUATION_MODAL_SET,
    payload: data
});

export const SPEClosedEvaluationChangeSet = (data) => ({
    type: SPE_CLOSED_EVALUATION_CHANGE_SET,
    payload: data
});

export const SPEClosedEvaluation = (page, num_page, orderBy, filters, data) => ({
    type: SPE_CLOSED_EVALUATION,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const SPEClosedEvaluationSuccess = (message) => ({
    type: SPE_CLOSED_EVALUATION_SUCCESS,
    payload: message
});

export const SPEClosedEvaluationError = (error) => ({
    type: SPE_CLOSED_EVALUATION_ERROR,
    payload: error
});

export const SPEDownloadEvaluationModalSet = (data) => ({
    type: SPE_DOWNLOAD_EVALUATION_MODAL_SET,
    payload: data
});

export const SPEDownloadEvaluationChangeSet = (data) => ({
    type: SPE_DOWNLOAD_EVALUATION_CHANGE_SET,
    payload: data
});

export const SPEChecklistScore = (data) => ({
    type: SPE_CHECKLIST_SCORE,
    payload: data
});

export const SPEChecklistScoreSuccess = (data) => ({
    type: SPE_CHECKLIST_SCORE_SUCCESS,
    payload: data
});

export const SPEChecklistScoreError = (error) => ({
    type: SPE_CHECKLIST_SCORE_ERROR,
    payload: error
});

export const SPEEditComiteModalSet = (data) => ({
    type: SPE_EDIT_COMITE_MODAL_SET,
    payload: data
});

export const SPEEditComiteChangeSet = (data) => ({
    type: SPE_EDIT_COMITE_CHANGE_SET,
    payload: data
});

export const SPEEditComite = (page, num_page, orderBy, filters, data) => ({
    type: SPE_EDIT_COMITE,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const SPEEditComiteSuccess = (message) => ({
    type: SPE_EDIT_COMITE_SUCCESS,
    payload: message
});

export const SPEEditComiteError = (error) => ({
    type: SPE_EDIT_COMITE_ERROR,
    payload: error
});

const speTool = (state) => state[NAME];

export const SPEToolSelector = createStructuredSelector({
    speTool
})